module.exports = __webpack_public_path__ + "img/44_39.99809fae.png";